import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { siteFeatures } from "@/mocks/criacao-sites";

export default function SiteFeatures() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Funcionalidades"
          badgeIcon="ri-apps-2-line"
          title="Seu site pode evoluir junto com sua empresa"
          description="Recursos que podem ser adicionados ao projeto conforme o seu negócio cresce e as necessidades mudam."
        />

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {siteFeatures.map((feature, index) => (
            <Reveal key={feature.label} delay={index * 40}>
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100/60 px-4 py-3.5 transition-colors hover:border-primary-200 hover:bg-background-50">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100/70 text-primary-700">
                  <i className={`${feature.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="text-sm font-medium text-foreground-800">{feature.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}